
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { CountriesDiseasesService } from './countries-diseases.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppMessages } from '../../../shared/constants/messages';
import { MdTooltipModule, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';
import { CountryDiseaseModel } from '../../../models/master-data/countries-diseases.model';

@Component({
    selector: 'add-new-country-disease',
    templateUrl: 'add-new-country-disease.component.html',
    providers: [CountriesDiseasesService]
})

export class AddNewCountryDiseaseComponent implements OnInit {
    title: string;
    countryDiseaseForm: FormGroup;
    countryDiseaseModel = new CountryDiseaseModel();
    formMessage = '';
    trips: any;
    diseases: any;
    public isSuccess = false;

    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        private countriesDiseasesService: CountriesDiseasesService,
        public dialogRef: MdDialogRef<AddNewCountryDiseaseComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.createForm();
    }

    ngOnInit() {
        this.countriesDiseasesService.getDiseaseList().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.diseases = data['list'];
                    this.removeDuplicate(this.data.dataList, this.diseases);
                }
            },
            error => {
            }
        );

        this.countriesDiseasesService.getTripList().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.trips = data['list'];
                }
            },
            error => {
            }
        );
        this.countryDiseaseForm.controls['countryId'].setValue(this.data.countryId);
        this.countryDiseaseModel.id = this.data.countryId;
        this.countryDiseaseModel.country = this.data.countryName;
        //this.countryDiseaseModel.trip = '-1';
    }

    createForm() {
        this.countryDiseaseForm = this.formBuilder.group({
            countryId: '',
            diseases: ['', [Validators.required]],
            tripCategoryId: ['', [Validators.required]],
            diseaseNote: ''
        });
    }

    onDiseaseChange(event) {
        this.countryDiseaseForm.controls['diseases'].setValue(event.value);
        // this.countryDiseaseForm.markAsDirty();
    }

    addNewCountryDisease(){
        this.countriesDiseasesService.addNewCountryDisease(this.countryDiseaseForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        )
    }


    onSubmit() {
        if (this.countryDiseaseForm.valid) {
            this.addNewCountryDisease();
        }
    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    removeDuplicate(listData, listCheck) {
        listData.forEach(data => {
            if (listCheck.findIndex(item => item.name === data.name) >= 0) {
                listCheck.splice(listCheck.findIndex(item => item.name === data.name), 1);
            }
        });
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/countries-diseases/add-new-country-disease.component.ts